import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchSaloons } from '../../../../redux/action/saloons/saloons';
import HomeMainTitle from '../../../homeTitle/HomeMainTitle'
import './style.scss'

const Categories = () => {
    const {t} = useTranslation();
    const saloons = useSelector(state => state.saloons)
    const dispatch = useDispatch()

    useEffect(() => {
        if(!saloons.saloons.length) {
            dispatch(fetchSaloons())
        }
    }, [])

    return (
        <>
        {saloons.saloons.length ?
            <div className='categories_container py-5'>
                <Container>
                    <HomeMainTitle>{t("Classification of industrial units")}</HomeMainTitle>
                    <div className='all_categories'>
                        {saloons.saloons.map(saloon => (
                            <Link to={`/saloon/${saloon.id}`} key={saloon.id} className='category'>
                                <h1>{saloon.name}</h1><h2>{ saloon.users_count } {t("company")}</h2>
                            </Link>
                        ))}
                    </div>
                </Container>
            </div>
        : 
            ''
        }
        </>
    )
}

export default Categories
